import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout.js";
import { RequireAuth } from "./components/RequireAuth.js";
import { ToastProvider } from "./components/Toast.js";
import { AnalyticsPage } from "./pages/AnalyticsPage.js";
import { AuditPage } from "./pages/AuditPage.js";
import { BuildsPage } from "./pages/BuildsPage.js";
import { ChangePasswordPage } from "./pages/ChangePasswordPage.js";
import { LoginPage } from "./pages/LoginPage.js";
import { OverviewPage } from "./pages/OverviewPage.js";
import { ReleasesPage } from "./pages/ReleasesPage.js";
import { SetupPage } from "./pages/SetupPage.js";
import { UsersPage } from "./pages/UsersPage.js";

export function App() {
  return (
    // Above the router: a toast raised by a mutation must survive the
    // navigation that mutation triggers.
    <ToastProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        {/* Outside the layout on purpose: a user who must rotate a seeded
            password should not even see the navigation. */}
        <Route
          path="/change-password"
          element={
            <RequireAuth>
              <ChangePasswordPage />
            </RequireAuth>
          }
        />
        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route path="/" element={<OverviewPage />} />
          <Route path="/releases" element={<ReleasesPage />} />
          <Route path="/builds" element={<BuildsPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/setup" element={<SetupPage />} />
          <Route
            path="/users"
            element={
              <RequireAuth roles={["admin"]}>
                <UsersPage />
              </RequireAuth>
            }
          />
          <Route
            path="/audit"
            element={
              <RequireAuth roles={["admin", "releaser", "analyst"]}>
                <AuditPage />
              </RequireAuth>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ToastProvider>
  );
}
